import { createStore, createEvent, combine, createEffect } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { DashboardApi } from '@shared/api/rest';
import type { DashboardItemsRequest, ExpenseCategory } from '@shared/api/rest/dashboards';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams<DashboardItemsRequest>) => DashboardApi.getExpenseCategories(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<ExpenseCategory[]>([])
  .on(effect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, (_, data) => ApiUtils.abortApiFailCaseTrigger(data))
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => {
  ApiUtils.errorStoreAbortRequestWatcher(x, $notificationStore.events.setError);
});

export const $dashboardExpenseCategoriesStore = {
  events: {
    update: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Abort),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
